import PropTypes from 'prop-types'
import React, { useState } from 'react'
import {
  CButton,
  CCol,
  CForm,
  CFormCheck,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CInputGroup,
  CRow,
} from '@coreui/react-pro'
import { OTHER_ICONS } from 'src/services/icons-list'
function LoginForm({
  loginFormValues,
  setloginFormValues,
  performLogin,
  otpEnabledMobileNos,
  checkOtpConfiguration,
  sendOtp,
  isOtpSent,
  performOtpLogin,
  selectedMobileNumverForOtp,
  setselectedMobileNumverForOtp,
  enteredOtp,
setenteredOtp
}) {
  const [passwordIsShown, setpasswordIsShown] = useState(false)
  return (
    <CRow className="g-0 h-100">
      <CCol sm={6} md={6} lg={6} xl={7} xxl={8} className="h-100 d-none d-sm-block"></CCol>
      <CCol
        sm={6}
        md={6}
        lg={6}
        xl={5}
        xxl={4}
        className="h-100 d-flex flex-column align-items-center justify-content-center p-4 p-md-4 p-lg-5 login-form-container"
      >
        <CFormLabel className="fs-2 text-white">Login</CFormLabel>
        <CForm className="w-100">
          <div className="d-flex align-items-center justify-content-around my-4">
            <CFormCheck
              type="radio"
              name="login_method"
              value="password_based"
              label="Password"
              className="text-white"
              defaultChecked={loginFormValues.login_method == 'password_based'}
              onChange={(e) => {
                if (e.target.checked) {
                  setloginFormValues((prev) => ({
                    ...prev,
                    login_method: 'password_based',
                  }))
                }
              }}
            />
            <CFormCheck
              type="radio"
              name="login_method"
              value="otp_based"
              label="OTP"
              className="text-white"
              defaultChecked={loginFormValues.login_method == 'otp_based'}
              onChange={(e) => {
                if (e.target.checked) {
                  setloginFormValues((prev) => ({
                    ...prev,
                    login_method: 'otp_based',
                  }))
                }
              }}
            />
          </div>
          <CFormLabel className="text-white">Login As</CFormLabel>
          <CFormSelect
            name="login_type"
            id="login_type"
            className="mb-3"
            value={loginFormValues.login_type}
            onChange={(e) => {
              setloginFormValues((prev) => ({
                ...prev,
                login_type: e.target.value,
              }))
            }}
          >
            <option value="STAFF">Staff</option>
            <option value="STUDENT">Student</option>
            <option value="PARENT">Parent</option>
          </CFormSelect>
          <CFormLabel className="text-white">Username</CFormLabel>
          <CFormInput
            className="mb-3"
            name="loginid"
            onChange={(e) => {
              setloginFormValues((prev) => ({
                ...prev,
                loginid: e.target.value,
              }))
            }}
            onBlur={() => checkOtpConfiguration()}
          />
          {loginFormValues.login_method == 'password_based' ? (
            <>
              <CFormLabel className="text-white">Password</CFormLabel>
              {/* <CFormInput type={passwordIsShown ? 'text' : 'password'} name='password' onChange={(e) => {
              setloginFormValues((prev) => ({
                ...prev,
                password: e.target.value,
              }))
            }}/> */}
              <CInputGroup>
                <CFormInput
                  type={passwordIsShown ? 'text' : 'password'}
                  id="inputGroupFile04"
                  aria-describedby="inputGroupFileAddon04"
                  aria-label="Upload"
                  name="password"
                  onChange={(e) => {
                    setloginFormValues((prev) => ({
                      ...prev,
                      password: e.target.value,
                    }))
                  }}
                />
                <CButton
                  type="button"
                  color="light"
                  id="inputGroupFileAddon04"
                  onClick={() => setpasswordIsShown((prev) => !prev)}
                >
                  {passwordIsShown ? (
                    <img src={OTHER_ICONS.hidePassword} height="20" />
                  ) : (
                    <img src={OTHER_ICONS.showPassword} height="20" />
                  )}
                </CButton>
              </CInputGroup>
            </>
          ) : (
            <></>
          )}
          {loginFormValues.login_method == 'otp_based' ? (
            <>
              <CFormLabel className="text-white">Mobile No.</CFormLabel>
              <CFormSelect
                name="mobile_no"
                id="mobile_no"
                className="mb-3"
                value={selectedMobileNumverForOtp}
                onChange={(e) => setselectedMobileNumverForOtp(e.target.value)}
              >
                <option value="">--Select--</option>
                {otpEnabledMobileNos.map((data, index) => {
                  return (
                    <option key={index} value={data.mobile_no}>
                      {data.hidden_no}
                    </option>
                  )
                })}
              </CFormSelect>
            </>
          ) : (
            <></>
          )}
          {loginFormValues.login_method == 'password_based' ? (
            <CButton
              color="success"
              className=" w-50 mt-4 float-end text-white"
              onClick={performLogin}
            >
              Login
            </CButton>
          ) : !isOtpSent ? (
            <CButton color="success" className=" w-50 mt-4 float-end text-white" onClick={sendOtp}>
              Send OTP
            </CButton>
          ) : (
            <div>
              <CFormLabel className="text-white">OTP</CFormLabel>
              <CFormInput
                type="text"
                id="otp"
                name="otp"
                value={enteredOtp}
                onChange={(e) => {
                  setenteredOtp(e.target.value)
                }}
              />
              <CButton
                color="success"
                className=" w-50 mt-4 float-end text-white"
                onClick={performOtpLogin}
              >
                Verify & Login
              </CButton>
            </div>
          )}
        </CForm>
      </CCol>
    </CRow>
  )
}

LoginForm.propTypes = {
  loginFormValues: PropTypes.object.isRequired,
  otpEnabledMobileNos: PropTypes.array.isRequired,
  setloginFormValues: PropTypes.func.isRequired,
  performLogin: PropTypes.func.isRequired,
  checkOtpConfiguration: PropTypes.func.isRequired,
  sendOtp: PropTypes.func.isRequired,
  performOtpLogin: PropTypes.func.isRequired,
  isOtpSent: PropTypes.bool.isRequired,
  selectedMobileNumverForOtp: PropTypes.string.isRequired,
  setselectedMobileNumverForOtp: PropTypes.func.isRequired,
  enteredOtp: PropTypes.string.isRequired,
  setenteredOtp: PropTypes.func.isRequired,
}
export default LoginForm
